@if (showBreadcrumb$ | async) {
    <nav aria-label="Breadcrumb" class="px-4 py-2">
        <ol class="flex flex-wrap items-center space-x-2 text-sm">
            <!-- Accueil -->
            <li>
                <a
                    [routerLink]="'/'"
                    class="text-gray-100 hover:text-third flex items-center"
                >
                    <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
                    </svg>
                    Accueil
                </a>
            </li>
            @for (item of breadcrumbs$ | async; track item.url) {
                <li class="flex items-center">
                    <svg class="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                    </svg>
                    @if (!isLastItem(item)) {
                        <a [routerLink]="item.url" class="ml-2 text-gray-100 hover:text-third flex items-center">
                            @if (item.icon) {
                                <mat-icon class="w-4 h-4 mr-1 text-gray-100">{{ item.icon }}</mat-icon>
                            }
                            <span>{{ item.label }}</span>
                        </a>
                    } @else {
                        <div class="ml-2 text-gray-300 font-medium flex items-center">
                            @if (item.icon) {
                                <mat-icon class="w-4 h-4 mr-1 text-gray-100">{{ item.icon }}</mat-icon>
                            }
                            <span>{{ item.label }}</span>
                        </div>
                    }
                </li>
            }
        </ol>
    </nav>
}